module.exports = __webpack_public_path__ + "522ce261209e4a3723d3b4d921c2c9a6.png";